import React, { memo, useMemo } from 'react';

import { Box } from '@mui/material';
import TableCDS from '@sharedCR/coreDesignSystem/Table/TableCDS';
import PropTypes from 'prop-types';

import { BorrowersTestIds } from '../../../../../../Borrowers.testIds';

import { derogatoryEventsTableConfig } from './DerogatoryEventsTable.config';
import {
  DEROGATORY_EVENTS_TITLE,
  NO_DEROGATORY_EVENTS_TEXT,
} from './DerogatoryEventsTable.constants';
import { getDerogatoryEventRows } from './DerogatoryEventsTable.utils';

/**
 * The derogatory events (bankruptcies, foreclosures, short sales, deeds-in-lieu) read from the
 * borrower's credit report, the records behind the credit-report event dates.
 */
const DerogatoryEventsTable = ({ derogatoryEvents = null, isLoading = false }) => {
  const rows = useMemo(() => getDerogatoryEventRows(derogatoryEvents), [derogatoryEvents]);

  return (
    <Box data-testid={BorrowersTestIds.DEROGATORY_EVENTS_TABLE}>
      <TableCDS
        withNoAvailableMessage
        config={derogatoryEventsTableConfig}
        data={rows}
        isLoading={isLoading}
        noAvailableMessageText={NO_DEROGATORY_EVENTS_TEXT}
        title={DEROGATORY_EVENTS_TITLE}
        withDivider={false}
      />
    </Box>
  );
};

DerogatoryEventsTable.propTypes = {
  derogatoryEvents: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
};

export default memo(DerogatoryEventsTable);
